import React from "react";
// import { FaEnvelope, FaPhone } from "react-icons/fa";
import "../css/Footer.css"; // Import global CSS file
import { useNavigate } from "react-router-dom";

const Footer: React.FC = () => {

    const navigate = useNavigate();

    const handleNavClick = (sectionId: string) => (e: React.MouseEvent) => {
        e.preventDefault();
        navigate(`/#${sectionId}`);
    };
    // const handleNavClickContactUs = (sectionId: string) => (e: React.MouseEvent) => {
    //     e.preventDefault();
    //     navigate(`/${sectionId}`);
    // };
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-section">
                    <p onClick={handleNavClick("about")} className="text-footer">About Us</p>
                    <p onClick={handleNavClick("board-ofdirectors")} className="text-footer">Our Directors</p>
                </div>

                <div className="footer-section">
                    <p onClick={handleNavClick("subsidiaries")} className="text-footer">Subsidiaries</p>
                    <p 
                        // onClick={handleNavClickContactUs("contact")} 
                        className="text-footer">Contact Us
                    </p>
                </div>
                <div className="footer-section">
                    <p className="address-title">Address</p>
                    <a
                        href="https://maps.app.goo.gl/jbVtSsE7BiiuDJddA"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="address-location"
                    >
                        #42, Samdach Pan Street(214), Sangkat Boeung Raing, Khan Daun Penh, Phnom Penh, 120204.
                    </a>

                    {/* <div className="contact-info">
                        <a href="mailto:info@sayon.com.kh" className="contact-item">
                            <FaEnvelope className="icon" />
                            <span>info@sayon.com.kh</span>
                        </a>
                        <a href="tel:+85581307999" className="contact-item">
                            <FaPhone className="icon" />
                            <span>(855) 81 307 999</span>
                        </a>
                    </div> */}
                </div>
            </div>

            {/* Copyright */}
            <div className="footer-bottom">
                <hr className="divider" />
                <p>© Copyright 2025. All rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;